import * as React from 'react';

import { Col } from 'react-bootstrap';
import { IChannel } from '../../../../../../data/api/models';

interface IFCDOTextProps {
  channel: IChannel;
}

class FCDOText extends React.Component<IFCDOTextProps> {

  public render() {

    const { channel } = this.props;

    if (channel.key === 'camc-b2c' || channel.key === 'tpl-b2c') {
      return (
          <Col sm={12}>
            <p>
              There is no cover to areas where the Foreign, Commonwealth & Development Office advised against
              all travel to your destination(s). For current information visit <a target="_blank"
                 href="https://www.gov.uk/foreign-travel-advice.">www.gov.uk/foreign-travel-advice</a>.
            </p>
          </Col>
      );
    }

    return (
          <Col sm={9}>
            <p>
              There is no cover to areas where the Foreign, Development &
              Commonwealth Office advised against all, or all but essential
              travel to your destination(s). For current information
            visit <a target="_blank"
                     href="https://www.gov.uk/foreign-travel-advice.">www.gov.uk/foreign-travel-advice.</a>
          </p>
        </Col>
    );
  }
}

export default FCDOText;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetailsJourneyB/components/FCDOText/index.tsx